
import SupportTicketDialog from './SupportTicketDialog'

const HEADER_BUTTON_SEEN_KEY = 'support_header_button_seen'

export default {
  components: { SupportTicketDialog },
  props: {
    buttonClass: {
      type: String,
      default: 'fixed bottom-2.5 z-40 rtl:left-5 ltr:md:right-5',
    },
  },
  data() {
    return {
      isOpen: false,
      showTooltip: false,
      config: null,
      configLoading: false,
      configError: false,
    }
  },
  mounted() {
    this.fetchConfig()
    this.showTooltip = !localStorage.getItem(HEADER_BUTTON_SEEN_KEY)
    if (this.$route.query.open_ticket === 'true') {
      this.handleOpen()
    }
  },
  methods: {
    handleOpen() {
      this.dismissTooltip()
      this.isOpen = true
    },
    dismissTooltip() {
      localStorage.setItem(HEADER_BUTTON_SEEN_KEY, '1')
      this.showTooltip = false
    },
    fetchConfig() {
      this.configLoading = true
      this.configError = false
      this.$axios
        .$get('v3/services/support-form')
        .then((res) => {
          this.config = res
        })
        .catch(() => {
          this.configError = true
        })
        .finally(() => {
          this.configLoading = false
        })
    },
  },
}
